<template>
  <v-data-table
    :headers="headers"
    :items="bookings"
    :search="search"
    :sort-by.sync="pagination.sortBy"
    :sort-desc.sync="pagination.descending"
    :custom-filter="filterOverAllProperty"
    :items-per-page="5"
    :loading="$store.getters['Ajax/loading'] ? 'accent' : false"
  >
    <template #item="props">
      <tr>
        <td class="">{{ formatDateView(props.item.creation_date) }}</td>
        <td>
          {{ props.item.reservation_number }}

          <v-chip small v-if="props.item.is_cancelled === 1" label outlined style="color: #FFE3F3; background-color: #ff99d0 !important;"
            >{{ $t("booking.canceled") }}
          </v-chip>
          <assigned-delegations-chip :delegations="props.item.delegations" />
        </td>
        <td class="py-2">
          <div>
            <v-row>
              <v-col class="flight-part">
                <div class="flight-airport">
                  <span class="bigger" style="font-weight: bold">
                    <span class="accent--text">{{ props.item.railAttributes.itinerary_from }}</span>

                    <span class="arrow">➞</span>
                    <span class="accent--text">{{ props.item.railAttributes.itinerary_to }}</span> </span
                  ><br />
                  <span v-if="props.item.railAttributes.start_time != null">{{ props.item.railAttributes.start_time.substr(0, 5) }} </span>
                  <span v-if="props.item.railAttributes.end_time != null">
                    -
                    {{ props.item.railAttributes.end_time.substr(0, 5) }}
                  </span>
                </div>
                <div class="flight-date grey--text" v-if="props.item.railAttributes.start_date != null">
                  {{ dayOfWeek(props.item.railAttributes.start_date.substr(0, 10)) }}
                  {{ formatDateView(props.item.railAttributes.start_date) }}
                </div>
              </v-col>
            </v-row>
          </div>
        </td>
        <td class="">{{ props.item.railAttributes.ticket_number }}</td>
        <td class="flight-airport">
          <span class="accent--text bigger">{{ props.item.railAttributes.carrier }}</span> <br />
          {{ $t("booking.class" + props.item.railAttributes.class_of_booking) }}
        </td>
        <td class="">
          <!-- eslint-disable-next-line -->
          <span v-for="passenger of props.item.passengers" style="text-transform: capitalize"> {{ passenger }} <br /> </span>
        </td>
        <td class="datatable-total-amount">
          <template v-if="props.item.invoice_gross_value !== null">{{ props.item.invoice_gross_value }} {{ props.item.invoice_currency }}</template>
          <template v-else-if="props.item.total_amount !== null">{{ props.item.total_amount }} PLN</template>
        </td>
        <td class="text-center text-no-wrap">
          <slot name="action-column" v-bind:booking="props.item">
            <v-tooltip bottom>
              {{ $t("global.goToDetails") }}
              <template #activator="{on}">
                <v-btn :to="'/booking/other/detail/' + props.item.id" class="mx-0" icon v-on="on">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom>
              {{ $t("global.downloadFile") }}
              <template #activator="{on}">
                <v-btn :disabled="$store.getters['Ajax/loading']" @click="downloadAttachment(props.item.id)" class="mx-0" icon v-on="on">
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </slot>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import dayOfWeek from "../../repository/shortDayOfWeekFromDate";
import filterOverAllProperty from "../../repository/filterOverAllProperty";
import formatDateView from "../../repository/fotmatDateView";
import AssignedDelegationsChip from "./AssignedDelegationsChip";
import downloadFile from "../../repository/downloadFile";

export default {
  name: "BookingRailDataTable",
  components: { AssignedDelegationsChip },
  props: {
    search: {
      type: String,
      default: "",
      required: false
    }
  },
  data: () => ({
    bookings: [],
    pagination: {
      sortBy: "creation_date",
      descending: true
    }
  }),
  computed: {
    isWNBUser() {
      return this.$store.getters["isWnbUser"];
    },
    headers() {
      return [
        { text: this.$t("booking.dateShort"), value: "creation_date" },
        { text: this.$t("booking.numberShort"), value: "reservation_number" },
        { text: this.$t("booking.rail.itinerary"), value: "", sortable: false },
        {
          text: this.$t("booking.ticketNumber"),
          value: "railAttributes.ticket_number"
        },
        {
          text: this.$t("booking.carrierAndClass"),
          value: "railAttributes.carrier"
        },
        {
          text: this.$t("booking.passengers"),
          sortable: false
        },
        { text: this.$t("booking.price"), value: "total_amount" },
        { text: "", value: "actions", sortable: false }
      ];
    }
  },
  methods: {
    dayOfWeek(val) {
      return dayOfWeek(val, this.$i18n.locale);
    },
    filterOverAllProperty: filterOverAllProperty,
    formatDateView: formatDateView,
    downloadAttachment(id) {
      downloadFile("booking/get-booking-file?bookingId=" + id);
    }
  },
  created() {
    this.axios.get("booking/get-rail").then(resp => {
      this.bookings = resp.data;
    });
  }
};
</script>

<style scoped>
.flight-direction {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.grey--text {
  color: #9e9e9e !important;
}

.bigger {
  margin-right: 4px;
  font-size: 15px;
}

.flight-airport {
  font-weight: 700;
  line-height: 1;
}

.flight-part {
  min-width: 175px;
}
</style>
